import ApiService from '../../services/ApiService.js';

export const namespaced = true;

export const state = {
	user: null
};

export const mutations = {
	SET_USER_DATA(state, data) {
		state.user = data;
		localStorage.setItem('user', JSON.stringify(data));
	},
	LOGOUT() {
		localStorage.removeItem('user');
		location.reload();
	}
	// ADD_EVENT(state, event) {
	// 	state.events.push(event);
	// },
};

export const actions = {
	// eslint-disable-next-line
	register({commit}, credentials) {
		return ApiService.register(credentials).then(({data}) => {
			commit('SET_USER_DATA', data);
		});
	},
	// eslint-disable-next-line
	login({commit}, credentials) {
		return ApiService.login(credentials).then(({data}) => {
			commit('SET_USER_DATA', data);
		});
	},
	logout({commit}) {
		commit('LOGOUT');
	}
	// createEvent({commit, dispatch}, event) {
	// 	return EventService.postEvent(event)
	// 		.then(() => {
	// 			commit('ADD_EVENT', event);
	// 			const notification = {
	// 				type: 'success',
	// 				message: 'Your event has been created!'
	// 			};
	// 			dispatch('notification/add', notification, {root: true});
	// 		})
	// 		.catch((error) => {
	// 			const notification = {
	// 				type: 'error',
	// 				message: 'There was a problem creating your event: ' + error.message
	// 			};
	// 			dispatch('notification/add', notification, {root: true});
	// 			throw error;
	// 		});
	// },
};

export const getters = {
	loggedIn(state) {
		//!!returns a check as a guaranteed boolean
		return !!state.user;
	},
	user(state) {
		return state.user;
	}
};
